@if (vm$ | async; as vm) {
  <uw-page-size-options [pageSizeOptions]="pageSizeOptions" (pageSizeOptionClick)="changePageSize($event)"></uw-page-size-options>
  <div class="paginator__container">
    <span [attr.aria-label]="'aria.navigate_previous_page' | translate">
      <mat-icon (click)="handlePreviousPage()">
        chevron_left
      </mat-icon>
    </span>
    @for (page of vm.pages; track page) {
      <span  (click)="handlePageClick(page)"> {{ page }} </span>
    }
    <span [attr.aria-label]="'aria.navigate_next_page' | translate">
      <mat-icon (click)="handleNextPage()">
        chevron_right
      </mat-icon>
    </span>
  </div>
}
